





































import { Vue, Component } from 'vue-property-decorator';
import ScheduleMeetingDialog from '@/components/brand/ScheduleMeetingDialog.vue';
import { BRAND_NAME } from '../../common/brand.config';
import brandModule from '../../store/modules/brand.module';

@Component({
  components: {
    ScheduleMeetingDialog,
  },
})
export default class TeamPage extends Vue {
  BRAND_NAME = BRAND_NAME;

  team = [];

  mounted(): void {
    this.team = this.$store.getters.teamMembers;
  }

  get brandUsers() {
    return brandModule.admins;
  }

  get brandName() {
    if (!brandModule.brand) { return; }
    return brandModule.brand.name;
  }
}
